export async function sendCommandFlex8(descricao, action) {
    const url = `${process.env.REACT_APP_SERVER_IP}/comandoFlex8`; 
    console.log(`Acionado o grupo de luz ${descricao} com a ação ${action}`);
  
    const data = {
        descricao: descricao,
        modulo: action.modulo,
        action: action.status,
        idx: action.idx,
    };
  
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        const responseData = await response.json();
        console.log('Resposta do servidor:', responseData);
    } catch (error) {
        console.error('Erro:', error);
    }
  }